export default __webpack_public_path__ + "static/blurred_background-84e284d49a96a2749d5743cb43428db0.jpg";